import React from "react";
import ObsIframe from "../../iframe-component/onboarding/ObsIframe";

const MerchantDocument = () => {
  return <ObsIframe path="/merchant" />;
};

export default React.memo(MerchantDocument);
